import Add20 from '@carbon/icons-react/es/add/20';
import Close16 from '@carbon/icons-react/es/close/16';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import styled from 'styled-components';
import { ifProp } from 'styled-tools';
import { Input as InputAtom } from 'components/atoms/input';
import { Text03 } from 'components/styles';

export const AddIcon = styled(Add20)`
  ${Text03};
`;

export const CloseIcon = styled(Close16)`
  cursor: pointer;
`;

export const Container = styled.div<{ size: SizeType }>`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

export const Input = styled(InputAtom)`
  margin-left: ${ifProp({ size: 'small' }, 'var(--spacing-03)', 0)};
  background: transparent;
  outline: none;
  border: none;
  padding-left: 0;
  &:focus {
    outline: none;
  }
`;
